import * as Sentry from '@sentry/nextjs';

import { DeviceCheckResult } from '~/generated/graphql';
import fetchFromElectron from '~/helpers/deviceChecks/fetchFromElectron';
import { DeviceCheckMetadata } from '~/types';

const checkOpenApps: DeviceCheckMetadata['check'] = async ({
  blacklistedApps,
  registrationDetails,
}) => {
  let openApps: string[] = [];

  try {
    window?.electron?.send('blacklistedApps', JSON.stringify(blacklistedApps));

    const promise = window.electron && fetchFromElectron('OPEN_APPS');
    const result = await promise;
    openApps = result?.data?.apps ?? [];

    openApps = Array.from(new Set(openApps));

    if (!result?.data) {
      return {
        result: DeviceCheckResult.Fail,
      };
    }

    Sentry.captureMessage(
      `Opened apps: ${openApps.join(', ')}; Registration Details: ${registrationDetails}`,
      'warning',
    );

    if (openApps.length !== 0) {
      return {
        result: DeviceCheckResult.Fail,
        value: openApps.join(', '),
      };
    }
    return {
      result: DeviceCheckResult.Pass,
      value: openApps.join(', '),
    };
  } catch (err) {
    const error = new Error(
      JSON.stringify({
        error: String(err),
        registrationDetails,
      }),
    );
    Sentry.captureException(error);

    return {
      result: DeviceCheckResult.Fail,
      value: openApps.toString(),
    };
  }
};

export default checkOpenApps;
